export const MAX_UPLOAD_FILE_SIZE = 5 * 1048576
export const BASE_INDEX = 0
export const COLOR_HEX_LENGTH = 7 //with aplha max = 9
export const MAX_FILENAME_LENGTH = 28
export const DEFAULT_FILE_NAME = 'flowcode'
